import {View} from 'backbone';

import BaseControlView from 'BaseControlView.js';
import template from 'report/control-chart.ejs';
import eventBus         from 'EventBus.js';
import constants        from "Constants.js";
import dragAndDropService from 'DragDropService.js';
import resizeController from 'ResizeController.js';
import * as d3 from 'd3.js';
import c3 from 'c3.js'; 


class BarChartView extends BaseControlView {

    initialize(opts) {
        super.initialize(opts);
        this.template = template;
        this.tagName = 'div';
        this.listenTo(eventBus, 'ButtonThemeChange', this.themeChangeRender);

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    chartConfiguration() {
        var c3config = {
            bindto: constants.ID_SEL + this.id +' div.c3-chart',
            legend: {show: false},
            size: {
                height: this.model.get('height') -2,
                width: this.model.get('width') -2
            }, // adjust for selectable border.
            axis: {
                rotated: false
            },
            bar: {
                width: {
                    ratio: 0.5
                }
            },
            data: {
                type: 'bar',
                columns: [
                    ['data1', 10, -5, 50, 20]
                ],
                colors:{
                    data1:this.model.get('barColor')
                }
            }
        };

        switch (this.model.get('axisVertical')) {
            case 'linear':
                console.log('Linear chosen');
                c3config.axis = {
                    y: {
                        tick: {
                            values: [-10, 0, 10, 20, 30, 40, 50]
                        }
                    },
                    rotated: false
                };
                break;
            case 'logaritmical':
                console.log('Logaritmical chosen');
                c3config.axis = {
                    y: {
                        tick: {
                            values: [1, 10, 100]
                        }
                    },
                    rotated: false
                };
                break;
            case 'dateTime':
                console.log('DateTime chosen');
                c3config.data = {
                    type: 'bar',
                    xs: {'y': 'x'},
                    columns: [
                        ['x', '1970-1-1', '1969-1-1'],
                        ['y', 10, -5, 50, 20]
                    ],
                    colors:{
                        x:this.model.get('barColor'),
                        y:this.model.get('barColor')
                    }
                };
                c3config.axis = {
                    x: {
                        type: 'timeseries',
                        tick: {
                            format: '%Y-%m-%d'
                        }
                    },
                    y: {
                        tick: {
                            values: [0, 20, 40, 60, 100]
                        }
                    },
                    rotated: true
                };
                break;
            case 'category': {
                console.log('Category chosen');
                c3config.axis = {
                    y: {
                        tick: {
                            values: [-12, -5, 50, 15]
                        }
                    },
                    rotated: false
                };
                break;
            }
        }

        switch (this.model.get('axisHorizontal')) {
            case 'linear':
                console.log('Linear Horizontal chosen');
                c3config.axis = {
                    x: {
                        tick: {
                            values: [0, 20, 40, 60, 80, 100]
                        }
                    },
                    rotated: false
                };
                break;
            case 'dateTime':
                console.log('DateTime  Horizontal chosen');
                c3config.data = {
                    type: 'bar',
                    xs: {'y': 'x'},
                    columns: [
                        ['x', '1970-1-1', '1969-1-1'],
                        ['y', 10, -5, 50, 20]
                    ],
                    colors:{
                        x:this.model.get('barColor'),
                        y:this.model.get('barColor')
                    }
                };
                c3config.axis = {
                    x: {
                        type: 'timeseries',
                        tick: {
                            format: '%Y-%m-%d'
                        }
                    },
                    rotated: false
                };
                break;
            case 'category':
                console.log('Category Horizontal chosen');
                c3config.axis = {
                    x: {
                        type: 'category',
                        categories: ['Jan', 'Feb', 'Mar', 'Apr']
                    },
                    rotated: false
                };
                break;
        }

        return c3config;
    }

    get kind() {
        return 'ButtonControlView';
    }

    render() {
        const generalChartSelector=constants.ID_SEL + this.id +' div.c3-chart';



        super.render();

        d3.select(generalChartSelector).style("background-color", "transparent");
        c3.generate(this.chartConfiguration());

        this.updateChartTextFont(generalChartSelector);

        this.updateChartTextColor(generalChartSelector);

        this.updateChartTextWeightAndStyle(generalChartSelector);

        this.updateChartAxisColor(generalChartSelector);

        return this;
    }


    updateChartTextFont(generalChartSelector){ 

        $(generalChartSelector +' .c3-axis-x').css('font-family', this.model.get('fontFamily'))
                                              .css('font-size',this.model.get('fontSize'));

        $(generalChartSelector +' .c3-axis-y').css('font-family', this.model.get('fontFamily'))
                                              .css('font-size',this.model.get('fontSize'));
    }

    updateChartTextColor(generalChartSelector){
        $(generalChartSelector +' .c3-axis-x text').css('fill',this.model.get('styleColorText'));
        $(generalChartSelector +' .c3-axis-y text').css('fill',this.model.get('styleColorText'));
    }

    updateChartTextWeightAndStyle(generalChartSelector){
        $(generalChartSelector +' .c3-axis-x').css('font-weight',this.model.get('textWeight').split(' ')[0])
                                              .css('font-style',this.model.get('textStyle').split(' ')[0]);
        $(generalChartSelector +' .c3-axis-y').css('font-weight',this.model.get('textWeight').split(' ')[0])
                                              .css('font-style',this.model.get('textStyle').split(' ')[0]);
    }

    updateChartAxisColor(generalChartSelector){
        $(generalChartSelector +' .c3-axis-x path').css('stroke',this.model.get('axisColor'));
        $(generalChartSelector +' .c3-axis-x line').css('stroke',this.model.get('axisColor'));
        $(generalChartSelector +' .c3-axis-y path').css('stroke',this.model.get('axisColor'));
        $(generalChartSelector +' .c3-axis-y line').css('stroke',this.model.get('axisColor'));
    }
}

export default BarChartView;
